export function createSharingApi(baseUrl) {
  return {
    sharing: {
      getObject: (id) => `${baseUrl}/v1/share/${id}/`,
      activePromo: (id) => `${baseUrl}/v1/promo/${id}`,
      appLink: (id) => `${baseUrl}/v1/share/${id}/link/`,
    },
  };
}
